import { render, staticRenderFns } from "./SubscriptionPracticeTest.vue?vue&type=template&id=f9e13af4"
import script from "./SubscriptionPracticeTest.vue?vue&type=script&lang=js"
export * from "./SubscriptionPracticeTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports